import React from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

const ProtectedFallback = () => {
  return (
    <ProtectedRoute fallbackPath="/">
      <Navigate to="/feed" replace />
    </ProtectedRoute>
  );
};

export default ProtectedFallback;
